import { icClose } from '@vivareal/lina-icons'

export default {
  name: 'oz-modal',

  props: {
    title: { type: String, required: true },
  },

  computed: {
    icon () {
      return icClose
    },
  },

  methods: {
    closeModal () {
      this.$emit('close-modal')
    },
  },
}
